module.exports = __webpack_public_path__ + "img/main-1.55d3974d.png";